











import { Prop, Component, Vue } from 'vue-property-decorator'
import { Referral } from '@/api/model/referral'
import CommentList from '@/components/comment/CommentList.vue'

@Component({
    components: { CommentList },
})
export default class CommentsPanel extends Vue {
    @Prop({ required: true }) readonly referral!: Referral

    onCommentsChanged() {
        this.$emit('commentsChanged', ...arguments)
    }
}
